import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { faHeart as faHeartOutline } from '@fortawesome/pro-regular-svg-icons'
import { faHeart } from '@fortawesome/pro-solid-svg-icons'

import { ItListAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'

import Icon from '../../Icon/Icon'

import useLikeButton from './useLikeButton'

const LikeButton = ({
  liked,
  itListId,
  trackingData,
  ...props
}: {
  liked: boolean
  itListId: number
  trackingData: ItListAnalyticsProps
} & Partial<IconButtonProps>) => {
  const { clickHandler, isLiked } = useLikeButton(liked, itListId, trackingData)

  return (
    <IconButton
      aria-label="Heart icon button"
      type="button"
      onClick={clickHandler}
      icon={
        <Icon
          icon={isLiked ? faHeart : faHeartOutline}
          boxSize="24px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        />
      }
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={1}
      variant={'roundWhite'}
      {...props}
    />
  )
}

export default LikeButton
